<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "journalWrapper"
};
</script>

<style scoped></style>
